/**
 * ConnectionBadge.jsx
 * ====================
 * Status pill with a coloured dot matching the desktop header style.
 *
 * Props
 * -----
 *   connectionStatus – "connecting" | "connected" | "disconnected" | "error"
 */

const STATUS_CONFIG = {
  connected: {
    pill:  'bg-[#1a2a1a] border border-[#2a4a2a] text-[#4ade80]',
    dot:   'bg-[#4ade80]',
    label: 'Connected',
    pulse: false,
  },
  connecting: {
    pill:  'bg-[#2a2a1a] border border-[#4a4a1a] text-[#facc15]',
    dot:   'bg-[#facc15]',
    label: 'Connecting…',
    pulse: true,
  },
  disconnected: {
    pill:  'bg-[#1e1e1e] border border-[#2a2a2a] text-[#666]',
    dot:   'bg-[#666]',
    label: 'Disconnected',
    pulse: false,
  },
  error: {
    pill:  'bg-[#2a1a1a] border border-[#4a1a1a] text-[#f87171]',
    dot:   'bg-[#f87171]',
    label: 'Error',
    pulse: false,
  },
};

export default function ConnectionBadge({ connectionStatus }) {
  const config = STATUS_CONFIG[connectionStatus] ?? STATUS_CONFIG.disconnected;
  const { pill, dot, label, pulse } = config;

  return (
    <span className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium select-none ${pill}`}>
      <span
        className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dot} ${pulse ? 'animate-pulse' : ''}`}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}
